<template>
	<div class="site-search">
		<div class="site-search__container">
			<svg-magnify-glass class="site-search__icon"></svg-magnify-glass>
      <span class="site-search__clear" @click="doClear">Clear</span>
			<input class="site-search__input" ref="search" v-model.trim="searchTerm" @input="doChange" @focus="doChange" :placeholder="placeholder"/>
		</div>
	</div>
</template>

<script>

export default {
  
	data() {
		return {
			searchTerm: '',
			placeholder: 'Search',
		}
	},

	created() {
		this.emitter.on("site:search:set",this.setTerm);
	},

	beforeUnmount() {
		this.emitter.off("site:search:set",this.setTerm);
	},

  mounted() {
    this.doFocus();
  },

	methods: {
		setTerm(term) {
			this.searchTerm = term;
			this.doChange();
		},
		doChange() {
			this.emitter.emit('site:search',this.searchTerm);
		},
    doClear() {
      this.searchTerm = '';
      this.doChange();
      this.doFocus();
    },
    doFocus() {
      this.$refs.search.focus();
    }
	}
}

</script>
